/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-name.reducer';

export const PatientNameDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientNameEntity = useAppSelector(state => state.patientName.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientNameDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientName.detail.title">PatientName</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientName.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.id}</dd>
          <dt>
            <span id="preferred">
              <Translate contentKey="tinyMedicRestApp.patientName.preferred">Preferred</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.preferred ? 'true' : 'false'}</dd>
          <dt>
            <span id="givenName">
              <Translate contentKey="tinyMedicRestApp.patientName.givenName">Given Name</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.givenName}</dd>
          <dt>
            <span id="prefix">
              <Translate contentKey="tinyMedicRestApp.patientName.prefix">Prefix</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.prefix}</dd>
          <dt>
            <span id="middleName">
              <Translate contentKey="tinyMedicRestApp.patientName.middleName">Middle Name</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.middleName}</dd>
          <dt>
            <span id="familyNamePrefix">
              <Translate contentKey="tinyMedicRestApp.patientName.familyNamePrefix">Family Name Prefix</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.familyNamePrefix}</dd>
          <dt>
            <span id="familyName">
              <Translate contentKey="tinyMedicRestApp.patientName.familyName">Family Name</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.familyName}</dd>
          <dt>
            <span id="familyNameSufix">
              <Translate contentKey="tinyMedicRestApp.patientName.familyNameSufix">Family Name Sufix</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.familyNameSufix}</dd>
          <dt>
            <span id="familyName2">
              <Translate contentKey="tinyMedicRestApp.patientName.familyName2">Family Name 2</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.familyName2}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientName.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.patientName.created">Created</Translate>
            </span>
          </dt>
          <dd>
            {patientNameEntity.created ? <TextFormat value={patientNameEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientName.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientName.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.timestampentry}</dd>
          <dt>
            <span id="totalReading">
              <Translate contentKey="tinyMedicRestApp.patientName.totalReading">Total Reading</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.totalReading}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientName.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientName.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.cursor}</dd>
          <dt>
            <span id="uuid">
              <Translate contentKey="tinyMedicRestApp.patientName.uuid">Uuid</Translate>
            </span>
          </dt>
          <dd>{patientNameEntity.uuid}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientName.doctor">Doctor</Translate>
          </dt>
          <dd>{patientNameEntity.doctor ? patientNameEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientName.pharmacist">Pharmacist</Translate>
          </dt>
          <dd>{patientNameEntity.pharmacist ? patientNameEntity.pharmacist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientName.diaglabAssistant">Diaglab Assistant</Translate>
          </dt>
          <dd>{patientNameEntity.diaglabAssistant ? patientNameEntity.diaglabAssistant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientName.hospitalAssistant">Hospital Assistant</Translate>
          </dt>
          <dd>{patientNameEntity.hospitalAssistant ? patientNameEntity.hospitalAssistant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientName.patient">Patient</Translate>
          </dt>
          <dd>{patientNameEntity.patient ? patientNameEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-name" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-name/${patientNameEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientNameDetail;
